import { ModuleTypes, ProductTypes } from '@/modules/base/util/constants'

export const SUBSCRIPTION_LEARN_MORE_PAGE_LINKS = {
  [ProductTypes.MAIN]: [
    'https://www.orgamax.de/akkordeon-omb1/',
    'https://www.orgamax.de/akkordeon-omb2/',
    'https://www.orgamax.de/akkordeon-omb3/',
    'https://www.orgamax.de/akkordeon-omb4/',
    'https://www.orgamax.de/akkordeon-omb5/',
    'https://www.orgamax.de/akkordeon-omb6/',
    'https://www.youtube.com/embed/1ZoEdhLyhs4?si=GpIOqOG8KBFF4kb7',
  ],
  [ProductTypes.DOCUMENT]: [
    'https://www.orgamax.de/akkordeon-omd1/',
    'https://www.orgamax.de/akkordeon-omd2/',
    'https://www.orgamax.de/akkordeon-omd3/',
    'https://www.orgamax.de/akkordeon-omd4/',
    'https://www.orgamax.de/akkordeon-omd5/',
  ],
  [ProductTypes.STAFF]: [
    'https://www.orgamax.de/akkordeon-omp1/',
    'https://www.orgamax.de/akkordeon-omp2/',
    'https://www.orgamax.de/akkordeon-omp3/',
    'https://www.orgamax.de/akkordeon-omp4/',
  ],
}

export const MAX_CART_COUNT = 10

const UNLIMITED_CART_MODULES: string[] = [ModuleTypes.STORAGE_PACKAGE]

export const getMaxCartCount = (moduleName: string) => UNLIMITED_CART_MODULES.includes(moduleName) ? Infinity : MAX_CART_COUNT

export const STORAGE_PACKAGE_SIZE_GB = 10

export const PRODUCT_ROUTE_MAP = {
  [ProductTypes.MAIN]: 'invoices',
  [ProductTypes.DOCUMENT]: 'documents',
  [ProductTypes.STAFF]: 'staff',
  all: '',
}

// /shop/<product>?step=addons opens the orgaMAX checkout at the add-ons of the current plan
export const SHOP_STEP_PARAM = 'step'
export const SHOP_ADDONS_STEP = 'addons'
